module.exports = "//public.zight.com/packs/media/images/annotate/tools-history-forward-disabled-c647d387d18e3a915a05d4352c104896.svg";